import { create } from 'zustand';
import { _APIS } from 'apis';

import request from 'request';

const useStore = create((set: any) => ({
  drawerOpen: false,
  drawerType: 'add',
  searchList: [],
  searchData: { page: 1, page_size: 9 },
  loadingList: false,
  total: 0,
  targetRecord: {},
  openDrawer: (record: any, drawerType: string) => {
    set({ drawerOpen: true, targetRecord: record, drawerType });
  },
  closeDrawer: () => {
    set({ drawerOpen: false, drawerType: '' });
  },
  activityExit: (params: any) => {
    return request.post(_APIS.MARKETING_ACTIVITIES.ACTIVITY_LIST.EXIT, params);
  },
  fetchList: (params: any) => {
    set({ loadingList: true });
    return request.post(_APIS.MARKETING_ACTIVITIES.ACTIVITY_LIST.SEARCH, params).then((res) => {
      const { list, total } = res?.data || {};
      const remainder = (list || []).length % 3;
      if (remainder) {
        const newArray = new Array(3 - remainder).fill({});
        newArray.forEach((item: any) => {
          list.push(item);
        });
      }
      (list || []).forEach((item: any) => {
        const { activity_cities, limit_cities, activity_veh_group } = item || {};
        item.activity_cities = limit_cities?.length ? `全部城市（不含-${limit_cities.join('、')})` : (activity_cities || []).join('、');
        item.activity_veh_group = activity_veh_group?.join('、');
      });
      set({searchList: list || [], loadingList: false, total, searchData: params});
      return res?.data;
    }).catch(() => {
      set({ loadingList: false });
    })
  },
  activityApply: (params:any) => {
    return request.post(_APIS.MARKETING_ACTIVITIES.ACTIVITY_LIST.APPLY,  params);
  },
  activityApplyUpdate: (params:any) => {
    return request.post(_APIS.MARKETING_ACTIVITIES.ACTIVITY_LIST.UPDATE,  params);
  },
  fetchDetail: (params: any) => {
    return request.get(_APIS.MARKETING_ACTIVITIES.ACTIVITY_LIST.DETAIL, { params })
  }
}))

export default useStore;